import { useCallback } from 'react';
import { useControlled, useInstanceId } from '@adsk/alloy-react-helpers';
import { useTranslation } from '../i18n';
export default (_ref => {
  let {
    defaultValue,
    value,
    onChange
  } = _ref;
  // Translation is used for ARIA, not the UI, so we can use it without suspense
  const {
    t: getUnsuspendedTranslation
  } = useTranslation('translation', {
    useSuspense: false
  });
  const [selectedValue, setSelectedValue] = useControlled(defaultValue, value, onChange);
  const menuId = "alloy-menu-".concat(useInstanceId());
  const getControlProps = useCallback(_ref2 => {
    let {
      show
    } = _ref2;
    return {
      'aria-haspopup': 'menu',
      'aria-expanded': show,
      'aria-label': getUnsuspendedTranslation('TOGGLE_MENU'),
      'aria-controls': menuId
    };
  }, [menuId, getUnsuspendedTranslation]);
  const getMenuProps = useCallback(() => ({
    id: menuId,
    value: selectedValue,
    onChange: setSelectedValue
  }), [menuId, selectedValue, setSelectedValue]);
  return {
    selectedValue,
    getControlProps,
    getMenuProps
  };
});
//# sourceMappingURL=useMenuButton.js.map